import { type FC } from 'react';
import cn from 'classnames';

import css from './styles.module.scss';

interface TopModalGradientProps {
  className?: string;
}

const TopModalGradient: FC<TopModalGradientProps> = ({ className }) => {
  return <span className={cn(css.topModalGradient, className)}></span>;
};

export { TopModalGradient };
